import React from "react";
import { DetialComponent } from "./style";
import { Row, Col } from "react-bootstrap";
import Button from "components/button";
import ColorSelector from "./components/colorSelector";
import NumberFormat from "components/numberFormat";
import GoldenWarrantySelector from "./components/goldenWarrantySelector";

const Detial = ({
  product,
  selectedOptions,
  selectOption,
  next,
  prev,
  showPic,
  changeImage,
}) => {
  const optionView = () => {
    let options = product.item.options;
    return Object.keys(options).map((key, index) => {
      switch (key) {
        case "color":
          return (
            <ColorSelector
              key={index}
              colors={options[key]}
              selected={selectedOptions[key]}
              onChange={(data) => {
                changeImage(data.color.reference);
                selectOption(data);
              }}
            />
          );
        case "golden_warranty":
          return (
            <GoldenWarrantySelector
              key={index}
              items={options[key]}
              selected={selectedOptions[key]}
              onChange={(data) => {
                selectOption(data);
              }}
            />
          );
        default:
          return null;
      }
    });
  };
  const selectedOptionsView = () => {
    return Object.keys(selectedOptions).map((key, index) => {
      return (
        <div key={index} className="grey-item">
          <span className="title">{selectedOptions[key].title}</span>
          <span className="value">
            {selectedOptions[key].added_price ? (
              <NumberFormat value={selectedOptions[key].added_price} />
            ) : (
              " اختلاف قیمت ندارد "
            )}
          </span>
        </div>
      );
    });
  };
  const lastPrice = () => {
    let firstPrice = product.price;
    let plus = 0;
    Object.keys(selectedOptions).forEach((key) => {
      plus = plus + selectedOptions[key].added_price;
    });
    let sum = firstPrice + plus;
    return sum;
  };
  return (
    <DetialComponent>
      <Row>
        <Col sm={12} md={4} lg={3}>
          <aside className="side">
            <div className="image">
              <img src={`./images/${product.item.car_model}/${showPic}.jpg`} alt="product" />
            </div>
            <div className="content">
              <div className="labels">
                <span>{product?.title}</span>
              </div>
              <div className="price-area">
                <div className="grey-item">
                  {product?.price_note}
                </div>
                {selectedOptionsView()}
                <div className="green-item">
                  قابل پرداخت: <NumberFormat value={lastPrice()} />
                </div>
              </div>
            </div>
          </aside>
        </Col>
        <Col sm={12} md={8} lg={9}>
          {optionView()}
          <div className="buttons">
            <Button title="مرحله قبل" onClick={prev} />
            <Button
              title="تایید و ادامه"
              onClick={() => {
                if(selectedOptions.golden_warranty && selectedOptions.golden_warranty.reference === 'yes') {
                  const confirmTxt    = 'اینجانب متقاضی خرید یک دستگاه خودروی آرینا درایو ایما هیبرید، با انتخاب گزینه کارت طلایی، با علم و آگاهی و اختیار کامل، درخواست خود را مبنی بر برخورداری از خدمات موصوف در ازای پرداخت مبلغ مذکور از طریق ساز و کار پیش‌بینی‌شده در سامانه فروش این شرکت، اعلام می‌دارم.'
                  const confirmResult = window.confirm(confirmTxt)
                  if(confirmResult) {
                    next()
                  }
                }else{
                  next()
                }
              }}
              disabled={
                Object.keys(product.item.options).length !==
                Object.keys(selectedOptions).length
              }
            />
          </div>
        </Col>
      </Row>
    </DetialComponent>
  );
};
export default Detial;
